import { buildSubmittedUserLabel } from 'utilities/user';
import XLSX from 'xlsx-js-style';

export const handleExportToExcel = (annotations, pageNumber) => {
  const headers = ['Slide', 'Order', 'Viewer', 'Submitted', 'Comment'];

  const worksheetData = [headers];
  annotations.forEach(({ comments, data, slide }) => {
    comments.forEach((comment) => {
      worksheetData.push([
        slide.name,
        slide.order.name,
        {
          t: 's',
          v: 'Link',
          l: { Target: data.target.source },
          s: {
            font: { color: { rgb: '0000FF' }, underline: true }, // blue link
          },
        },
        buildSubmittedUserLabel(comment.user, comment.created),
        comment.value,
      ]);
    });
  });

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  const fileName = `annotations-page${pageNumber}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};
